import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const OfferSection = () => {
  return <section className="py-8" data-id="element-386">
      <FadeIn data-id="element-387">
        <div className="text-center mb-10" data-id="element-388">
          <h2 className="text-sm font-bold tracking-widest text-amber-500 uppercase mb-3" data-id="element-389">
            Presentamos
          </h2>
          <h3 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-390">
            📘 El Mapa de la Noche Sin Reflujo
          </h3>
          <p className="text-xl text-slate-300" data-id="element-391">
            El Protocolo 3-2-1 de Gravedad e Intervalos para Eliminar el Ardor
            Nocturno en 7 Días
          </p>
        </div>

        <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden shadow-2xl mb-10" data-id="element-392">
          <div className="bg-slate-800 p-6 border-b border-slate-700" data-id="element-393">
            <h4 className="text-xl font-bold text-white text-center" data-id="element-394">
              ¿Qué obtienes exactamente?
            </h4>
          </div>

          <div className="divide-y divide-slate-800" data-id="element-395">
            {[{
            icon: '📘',
            title: 'Principal',
            desc: 'El Protocolo 3-2-1 completo: intervalos, posición y mecánica del descanso',
            value: '$19'
          }, {
            icon: '🛏️',
            title: 'Guía de Ingeniería del Descanso',
            desc: 'Cómo inclinar tu cama correctamente sin gastar en equipos caros',
            value: '$9'
          }, {
            icon: '🚨',
            title: 'Kit de Rescate de Emergencia',
            desc: '4 pasos para detener un ataque de acidez a las 2 AM en menos de 5 minutos',
            value: '$9'
          }, {
            icon: '✅',
            title: 'Checklist de Auditoría Pre-Sueño',
            desc: 'Tu lista de verificación nocturna para garantizar una noche libre de fuego',
            value: '$7'
          }, {
            icon: '📋',
            title: 'Hoja de Trabajo: Diario de Disparadores',
            desc: 'Identifica exactamente qué activa tu reflujo en menos de 3 días',
            value: '$7'
          }, {
            icon: '🍽️',
            title: 'Guía de 7 Cenas de Baja Presión',
            desc: 'Recetas rápidas (10 min) que no activan el reflujo nocturno',
            value: '$9'
          }].map((item, i) => <div key={i} className="p-4 sm:p-6 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between hover:bg-slate-800/50 transition-colors" data-id="element-396">
                <div className="flex items-start gap-4" data-id="element-397">
                  <span className="text-2xl" data-id="element-398">{item.icon}</span>
                  <div data-id="element-399">
                    <strong className="text-white block" data-id="element-400">{item.title}</strong>
                    <span className="text-sm text-slate-400" data-id="element-401">{item.desc}</span>
                  </div>
                </div>
                <div className="text-slate-500 font-medium whitespace-nowrap" data-id="element-402">
                  Valor: {item.value}
                </div>
              </div>)}
          </div>

          <div className="bg-slate-950 p-6 sm:p-8 border-t border-slate-700 flex flex-col items-center justify-center gap-2" data-id="element-403">
            <div className="text-slate-400 text-lg line-through mb-1" data-id="element-404">
              VALOR TOTAL: $60
            </div>
            <div className="text-3xl sm:text-5xl font-black text-amber-500 flex items-center gap-3" data-id="element-405">
              <span data-id="element-406">🔥</span> TU PRECIO HOY: $13.99
            </div>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-407">
        <div className="rounded-2xl overflow-hidden border border-slate-800 shadow-2xl" data-id="element-408">
          <img src="https://cdn.magicpatterns.com/uploads/ureAhcqhpH15ZaDjW1cNZq/heylloyd-image-noche_reflujo_.png" alt="Mockup del producto en múltiples dispositivos" className="w-full h-auto object-cover" data-id="element-409" />
        </div>
      </FadeIn>
    </section>;
};